import { useState, useEffect } from "react";
import ManageTeamModal from "layouts/profile/components/Workspaces/ManageTeamModal";
import UserService from "services/user-service";

/**
 * RequireInviteStep — onboarding gate that fires once after first workspace+profile setup.
 *
 * Reads the `firstWorkspaceSetup` sessionStorage flag set by CreateWorkspaceModal (forced mode).
 * Shows ManageTeamModal in onboarding mode when the flag is present, then clears it.
 * For all other users/situations, renders children immediately.
 */
const RequireInviteStep = ({ children }) => {
    const needsInviteStep = sessionStorage.getItem("firstWorkspaceSetup") === "true";
    const [showInvite, setShowInvite] = useState(needsInviteStep);
    const [workspaceId, setWorkspaceId] = useState("");
    const [workspaceName, setWorkspaceName] = useState("your workspace");

    useEffect(() => {
        if (!needsInviteStep) return;
        // Fetch the active workspace name from backend
        UserService.fetchUserWorkspaces()
            .then((res) => {
                const list = Array.isArray(res) ? res : (res?.data || []);
                const active = list.find((w) => w.is_active);
                if (active) {
                    setWorkspaceId(active.workspace_id?._id || "");
                    setWorkspaceName(active.workspace_id?.name || "your workspace");
                }
            })
            .catch((err) => console.error("RequireInviteStep: failed to fetch workspaces", err));
    }, []);

    const handleClose = () => {
        sessionStorage.removeItem("firstWorkspaceSetup");
        sessionStorage.removeItem("firstWorkspaceName");
        setShowInvite(false);
    };

    if (showInvite) {
        return (
            <ManageTeamModal
                open={true}
                onClose={handleClose}
                workspaceId={workspaceId}
                workspaceName={workspaceName}
                isOnboarding={true}
            />
        );
    }

    return children;
};

export default RequireInviteStep;
